import { KycResponse, KycStatus } from '../../../../apis/user/types';
import { addDays } from 'date-fns';
import { KYC_EXPIRY_WARNING_DAYS } from '../../../../components/Navigation/Checkers/constants';
import { ProcessedTraderKycStatus } from './types';

export function getTraderKycStatus(
  kycResponse: KycResponse | undefined,
): ProcessedTraderKycStatus {
  const kyc = (kycResponse as KycResponse)?.statuses?.[0];
  const passed = kyc?.status === KycStatus.APPROVED;
  const rejectedCanRestart = KycStatus.REJECTED_RETRY === kyc?.status;
  const rejected = KycStatus.REJECTED === kyc?.status;
  const inProgress = KycStatus.PENDING === kyc?.status;
  const canStart = (
    [
      KycStatus.EXPIRED,
      KycStatus.INIT,
      KycStatus.NOT_STARTED,
      KycStatus.REJECTED_RETRY,
    ] as KycStatus[]
  ).includes(kyc?.status);

  return {
    passed,
    rejected,
    rejectedCanRestart,
    inProgress,
    canStart,
    category: kyc?.category,
    reason: kyc?.reason,
    level: kyc?.level,
    ...isKycExpiredOrExpiring(kycResponse),
  };
}

export function isKycExpiredOrExpiring(kyc?: KycResponse): {
  expired: boolean;
  expiring: boolean;
  kycExpiryDate: string;
} {
  const kycExpiryDate = kyc?.statuses?.[0]?.expiration_date;
  const expiring =
    kycExpiryDate &&
    +addDays(new Date(kycExpiryDate!), -KYC_EXPIRY_WARNING_DAYS) < Date.now();
  const expired = kycExpiryDate && +new Date(kycExpiryDate) < Date.now();
  return {
    expired,
    expiring: !expired && expiring,
    kycExpiryDate,
  };
}
